import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';

const AddSalesVisit = () => {
    const [name, setName] = useState('');
    const [sales, setsales] = useState('');
    const [area, setArea] = useState('');
    const [city, setCity] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState(null);
    const navigate = useNavigate();

    // Handle file input change
    const handleFileChange = (e) => {
        setImage(e.target.files[0]);
    };

    // Handle form submit
    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('name', name);
        formData.append('area', area);
        formData.append('city', city);
        formData.append('sales', sales);
        formData.append('description', description);
        formData.append('image', image);

        fetch(`${BASE_URL}salesvisits`, {
            method: 'POST',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    alert('Sales visit added successfully!');
                    navigate('/SalesVisitsList'); // Redirect to the list of sales visits
                } else {
                    alert('Failed to add sales visit: ' + data.message);
                }
            })
            .catch(error => {
                console.error('Error adding sales visit:', error);
                alert('Error adding sales visit');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Sales Visit</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add New Sales Visit</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Firm Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="area" className="form-label">Area</label>
                                        <input
                                            type="text"
                                            id="area"
                                            className="form-control"
                                            value={area}
                                            onChange={(e) => setArea(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="city" className="form-label">City</label>
                                        <input
                                            type="text"
                                            id="city"
                                            className="form-control"
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="sales" className="form-label">PCS of Sale</label>
                                        <input
    type="text"
    id="sales"
    className="form-control"
    value={sales}
    maxLength={10}
    onChange={(e) => {
        // Allow only numbers (0-9)
        const numericValue = e.target.value.replace(/[^0-9]/g, '');
        setsales(numericValue);
    }}
    required
/>

                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={handleFileChange}
                                            accept="image/*"
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Add Sales Visit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddSalesVisit;
